
export class Question {

	uuid?: string;
	code: number;
	description: string;
	answer: any;
	type?: number;
	integers?: number;
	decimals?: number;
	size?: number;
	mask?: Array<any> = [];

	constructor() {}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/autentication/models/question.ts